import { useState } from 'react';
import {
  MAIN_MENU_STORAGE_KEY,
  normalizeMainMenuKey,
  type MainMenuKey,
} from '@/utils/mainMenu';

const getInitMainMenu = (): MainMenuKey => {
  try {
    const cacheValue = localStorage.getItem(MAIN_MENU_STORAGE_KEY);
    return normalizeMainMenuKey(cacheValue || undefined);
  } catch (error) {
    console.error('读取主菜单缓存失败：', error);
    return 'commercial';
  }
};

export default function useMenuModel() {
  const [activeMainMenu, setActiveMainMenuState] = useState<MainMenuKey>(
    getInitMainMenu,
  );

  const setActiveMainMenu = (key: MainMenuKey) => {
    setActiveMainMenuState(key);
    try {
      localStorage.setItem(MAIN_MENU_STORAGE_KEY, key);
    } catch (error) {
      console.error('写入主菜单缓存失败：', error);
    }
  };

  const resetMainMenu = () => {
    setActiveMainMenuState('commercial');
    localStorage.removeItem(MAIN_MENU_STORAGE_KEY);
  };

  return {
    activeMainMenu,
    setActiveMainMenu,
    resetMainMenu,
  };
}
